import { __assign } from "tslib";
import { AsyncState, IAction, IAsyncState } from "../action";
import { actionTypes } from "../actions";
var initialState = new AsyncState();
export function dataOptimized(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case actionTypes.loadScopeNames:
            if (action.payload) {
                return state;
            }
            return initialState;
        case actionTypes.dimensionsLoaded:
        case actionTypes.dataModelNamesLoaded:
        case actionTypes.reportRequestGenerated:
            return initialState;
        case actionTypes.loadDataOptimized:
            return __assign(__assign({}, state), { isFetching: true, timestamp: new Date() });
        case actionTypes.dataOptimizedLoaded:
            return __assign(__assign({}, state), action.payload);
        default:
            return state;
    }
}
